export const calculateStringSizeInKb = (str: string) => {
  const { size } = new Blob([str]);

  return Math.round((size / 1024) * 100) / 100;
};
